export default {
  LOAD_CYCLE_CASE_DIAGNOSIS_TLK_DIALOG_START: 'LoadCycleCaseDiagnosisTlkDialogStart',
  LOAD_CYCLE_CASE_DIAGNOSIS_TLK_DIALOG_END: 'LoadCycleCaseDiagnosisTlkDialogEnd',
  ADD_CYCLE_CASE_DIAGNOSIS_TLK_DIALOG_START: 'AddCycleCaseDiagnosisTlkDialogStart',
  ADD_CYCLE_CASE_DIAGNOSIS_TLK_DIALOG_END: 'AddCycleCaseDiagnosisTlkDialogEnd'
};